"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSortDescending = (property) => property.indexOf('-') === 0;
exports.getSortProperty = (sort) => exports.isSortDescending(sort) ? sort.substr(1) : sort;



//////////////////
// WEBPACK FOOTER
// ./src/components/Datagrid/utils/string.ts
// module id = 104
// module chunks = 0